import styled from 'styled-components';

export const PageTask = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  min-height: 100vh;
  background: rgb(255,255,255);
  background: linear-gradient(170deg, rgba(255,255,255,1) 0%, rgba(220,233,246,1) 35%);
`;